/* eslint-disable */
import FootStrikeCardFoot from "components/footstrikeFootComponent/FootstrikeFoot";
import "../../styles/sessionSummary.scss";
import { calculateTwoValueAsymmetry, LoadGauge } from "utils/helper";
import MainTooltip from "components/common/mainTooltip/MainTooltip";
import { useEffect, useRef, useState } from "react";
import MainToggler from "components/common/toggler/MainToggler";
import { nanoid } from "@reduxjs/toolkit";
import { debounce } from "lodash";

const AsymmetryGauge = (props) => {
  const { data, summaryMetricKey, graphDomain } = props;

  const dataFiltered = data
    .filter((item) =>
      graphDomain
        ? item.timeOfStep >= graphDomain[0] && item.timeOfStep <= graphDomain[1]
        : item
    )
    .map((item) => item?.[summaryMetricKey])
    .filter((item) => item !== null);
  const asymmetry =
    dataFiltered.reduce(
      (accumulator, currentValue) => accumulator + currentValue,
      0
    ) / dataFiltered.length;

  return (
    <div className="asymmetry_gauge_container">
      <div className="gauge_divider"></div>
      <div
        className="asymmetry_gauge"
        style={
          asymmetry < 0
            ? { justifyContent: `flex-end` }
            : { justifyContent: `flex-start` }
        }
      >
        <div
          className="left_gauge"
          style={
            asymmetry < 0
              ? { width: `${(asymmetry * -1) / 2}%` }
              : { width: `50%`, backgroundColor: "transparent" }
          }
        ></div>

        <div
          className="right_gauge"
          style={
            asymmetry > 0
              ? { width: `${asymmetry / 2}%` }
              : { width: `50%`, backgroundColor: "transparent" }
          }
        ></div>
      </div>
    </div>
  );
};

const SessionSummary = (props) => {
  const {
    summaryMetricTitle,
    sessionSummaryClassName,
    sessionSummaryID,
    sessionSummaryCards,
    sessionData,
    getSucceededData,
    graphDomain,
    hasValueToggler = false,
    disabledSummaryIDs,
    selectedActivityType = false
  } = props;

  const isDevEnvironment = process.env.REACT_APP_API_HOST.includes("dev");

  //setting number of columns for grid display, based on number of cards and screen width
  const [columns, setColumns] = useState(sessionSummaryCards.length);

  const summaryRef = useRef(null)


  //setting
  const [toggled, setToggled] = useState("avg");

  //when screen length changes alter number of columns used in the grid
  useEffect(() => {
    const updateColumns = () => {
      if (!summaryRef.current) {
        // console.log("summaryRef is undefined!");
        return;
      }

      const cards = summaryRef.current.querySelectorAll(".symmetry_card");
      const sourceLength = cards.length || 0;

      const windowWidth = window.innerWidth;
      if (windowWidth <= 425) {
        setColumns(1); // For mobiles and smaller screen sizes
      } else if (windowWidth <= 820) {
        if(cards.length > 1){

          setColumns(Math.ceil(sourceLength / 2)+1); // For medium screens
        }else {
          
          setColumns(Math.ceil(sourceLength / 2)); // For medium screens
        }
      } else {
        setColumns(sourceLength); // For larger screens
      }
    };

    updateColumns();

    const observer = new MutationObserver(updateColumns);
    if (summaryRef.current) {
      observer.observe(summaryRef.current, { childList: true, subtree: true });
    }

    window.addEventListener("resize", updateColumns);

    return () => {
      window.removeEventListener("resize", updateColumns);
      observer.disconnect();
    };
  }, [sessionSummaryCards, disabledSummaryIDs, sessionData]);

  const data = getSucceededData(sessionData)?.raw || getSucceededData(sessionData)?.rawData;

  console.log(data)
  

  const calculateAverageOfObject = (
    data,
    summaryPrimaryKey,
    summaryMetricKey,
    operation = "avg" // Default operation is 'avg'
  ) => {

    // Filter data based on the timeOfStep and graphDomain
    const dataValues = data?.[summaryPrimaryKey]?.filter((item) =>
      graphDomain
        ? item.eventStart >= graphDomain[0] && item.eventEnd <= graphDomain[1]
        : item
    );

    // Filter out items where the summaryMetricKey is null
    const filteredValues = dataValues?.filter(
      (item) => item?.[summaryMetricKey] !== null
    );

    if (!filteredValues?.length) return "0.00"; // Return '0.00' if no valid data is found

    // Determine the operation to perform: avg, min, or max
    switch (operation) {
      case "min":
        return Math.min(
          ...filteredValues.map((item) => item?.[summaryMetricKey])
        ).toFixed(2);

      case "max":
        return Math.max(
          ...filteredValues.map((item) => item?.[summaryMetricKey])
        ).toFixed(2);

      case "avg":
      default:
        const sum = filteredValues.reduce(
          (acc, obj) => acc + obj?.[summaryMetricKey],
          0
        );
        const average = sum / filteredValues.length;
        return average.toFixed(2);
    }
  };

  const calculateAverageOfFootStrikeObject = (
    data,
    summaryPrimaryKey,
    summaryMetricKey,
    summaryMetricUnit
  ) => {
    const leftData =  !selectedActivityType ? data?.[summaryPrimaryKey]?.[summaryMetricKey?.[0]]:  data?.[summaryPrimaryKey]?.[selectedActivityType?.index]?.[summaryMetricKey?.[0]];
    const rightData =  !selectedActivityType ? data?.[summaryPrimaryKey]?.[summaryMetricKey?.[1]]:  data?.[summaryPrimaryKey]?.[selectedActivityType?.index]?.[summaryMetricKey?.[1]];

    function calculateHighestPercentage(obj1, obj2) {
      const combined = {
        Front: (obj1?.Front || 0) + (obj2?.Front || 0),
        Middle: (obj1?.Middle || 0) + (obj2?.Middle || 0),
        Back: (obj1?.Back || 0) + (obj2?.Back || 0),
      };

      const totalSum = combined?.Front + combined?.Middle + combined?.Back;

      let highestKey = null;
      let highestValue = -Infinity;
      let keysWithMaxValue = [];

      for (let key in combined) {
        if (combined?.[key] > highestValue) {
          highestValue = combined?.[key];
          keysWithMaxValue = [key];
        } else if (combined?.[key] === highestValue) {
          keysWithMaxValue.push(key);
        }
      }

      highestKey = keysWithMaxValue[0];

      const percentage = ((highestValue / totalSum) * 100).toFixed(1);

      const labelMap = {
        Front: "FOREFOOT",
        Middle: "MIDFOOT",
        Back: "HEEL",
      };

      return `${percentage} ${summaryMetricUnit} ${labelMap[highestKey]}`;
    }

    return calculateHighestPercentage(leftData, rightData);
  };

  const calculateAsymmetry = (data, summaryMetricKey) => {
    const dataValues = data
      .filter((item) =>
        graphDomain
          ? item.timeOfStep >= graphDomain[0] &&
            item.timeOfStep <= graphDomain[1]
          : item
      )
      .map((item) => item?.[summaryMetricKey])
      ?.filter((value) => value !== null);

    const asymmetryValue =
      dataValues?.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      ) / dataValues?.length;

    if (asymmetryValue < 0) {
      return `${(asymmetryValue * -1)?.toFixed(2)}% Left`;
    } else {
      return `${asymmetryValue?.toFixed(2)}% Right`;
    }
  };

  const isDevOnly = (env, isDevOnly) => {
    if (isDevOnly !== undefined) {
      return isDevOnly ? env : !env;
    }
    return true;
  };

  const devOnlyTooltip = (env, isDevOnly) => {
    if (isDevOnly !== undefined) {
      return isDevOnly ? env : !env;
    }
  } 

  return data && Object?.keys(data)?.length ? (
    <div className={sessionSummaryClassName} id={sessionSummaryID}>
      <div className="summary_heading">
        <h4>{summaryMetricTitle}</h4>
        {hasValueToggler ? (
          <MainToggler
            uniqueName={nanoid()}
            toggleValue={toggled}
            setIsToggled={setToggled}
            togglerHeadings={[
              { heading: "Min", value: "min" },
              { heading: "Average", value: "avg" },
              { heading: "Max", value: "max" },
            ]}
          />
        ) : null}
      </div>
      <div
        className="summary_cards"
        style={{
          gridTemplateColumns: `repeat(${columns}, ${100 / columns - 0.8}%)`,
        }}
        ref={summaryRef}
      >
        {sessionSummaryCards.map((item, index) => {
          if (!disabledSummaryIDs.includes(item.summaryID) && isDevOnly(isDevEnvironment, item.summaryDevOnly)) {
            if (item.summaryType === "meanCard") {
              return (
                <div
                  className="symmetry_card kpi_card"
                  key={`kpi_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>
                      {toggled + "." + item.summaryName}
                      {item.summaryMetricUnit ? (
                        <span className="unit">
                          {" "}
                          ({item.summaryMetricUnit})
                        </span>
                      ) : null}
                    </h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                    {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <h3>{`${calculateAverageOfObject(
                    data,
                    item.summaryPrimaryKey,
                    item.summaryMetricKey,
                    toggled
                  )}`}</h3>
                </div>
              );
            } else if (item.summaryType === "footStrikeCard") {
              return (
                <div
                  className="symmetry_card kpi_card"
                  key={`kpi_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>
                      {item.summaryName}
                      {item.summaryMetricUnit ? (
                        <span className="unit">
                          {" "}
                          ({item.summaryMetricUnit})
                        </span>
                      ) : null}
                    </h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <h3>{`${calculateAverageOfFootStrikeObject(
                    data,
                    item.summaryPrimaryKey,
                    item.summaryMetricKeys,
                    item.summaryMetricUnit
                  )}`}</h3>
                </div>
              );
            }else if (item.summaryType === "countCard" && data?.[item.summaryPrimaryKey]) {
              return (
                <div
                  className="symmetry_card kpi_card"
                  key={`kpi_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>
                      {item.summaryName}
                      {item.summaryMetricUnit ? (
                        <span className="unit">
                          {" "}
                          ({item.summaryMetricUnit})
                        </span>
                      ) : null}
                    </h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <h3>{data?.[item.summaryPrimaryKey]?.[item.summaryMetricKey]}</h3>
                </div>
              );
            } else if (item.summaryType === "dualMeanCard") {
              return (
                <div
                  className="symmetry_card kpi_card"
                  key={`kpi_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>
                      {item.summaryName}
                      {item.summaryMetricUnit ? (
                        <span className="unit">
                          {" "}
                          ({item.summaryMetricUnit})
                        </span>
                      ) : null}
                    </h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <h3 className="single_foot_left">
                    {`${calculateAverageOfObject(
                      data,
                      item?.summaryPrimaryKeys[0],
                      item.summaryMetricKey,
                      toggled
                    )} `}
                    <span className="foot">L</span>
                  </h3>
                  <h3 className="single_foot_right">
                    {`${calculateAverageOfObject(
                      data,
                      item?.summaryPrimaryKeys[1],
                      item.summaryMetricKey,
                      toggled
                    )} `}{" "}
                    <span className="foot">R</span>
                  </h3>
                </div>
              );
            } else if (item.summaryType === "loadCard") {
              return (
                <div
                  className="symmetry_card symm_card"
                  key={`asymmetry_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>{item.summaryName}</h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <LoadGauge
                    leftValue={
                      !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[0]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[0]
                        ]
                    }
                    rightValue={
                      !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[1]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[1]
                        ]
                    }
                  />
                  <h3>
                    {data?.[item.summaryPrimaryKey]?.[item.summaryMetricKey]}
                  </h3>
                </div>
              );
            } else if (item.summaryType === "asymmetryCard") {
              return (
                <div
                  className="symmetry_card symm_card"
                  key={`asymmetry_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>{item.summaryName}</h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <AsymmetryGauge
                    data={ data?.[item?.summaryPrimaryKey]}
                    summaryMetricKey={item.summaryMetricKey}
                    graphDomain={graphDomain}
                  />
                  <h3>
                    {calculateAsymmetry(
                      data?.[item.summaryPrimaryKey],
                      item.summaryMetricKey
                    )}
                  </h3>
                </div>
              );
            } else if (item.summaryType === "asymmetryPercentageCard") {
              return (
                <div
                  className="symmetry_card symm_card"
                  key={`asymmetry_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>{item.summaryName}</h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <LoadGauge
                    leftValue={
                      !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[0]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[0]
                        ]
                    }
                    rightValue={
                      !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[1]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[1]
                        ]
                    }
                    percentageDifference={true}
                  />
                  <h3>
                    {calculateTwoValueAsymmetry(
                      !selectedActivityType ?
                      data?.[item.summaryPrimaryKey]?.[
                        item.summaryMetricKeys[0]
                      ] : 
                      data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                        item.summaryMetricKeys[0]
                      ],
                      !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[1]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[1]
                        ]
                    )}
                  </h3>
                </div>
              );
            } else if (item.summaryType === "footStrikeWithFeetCard") {
              return (
                <div
                  className="symmetry_card symm_card"
                  key={`asymmetry_card_${index}`}
                  id={item.summaryID}
                >
                  <div className="symmetry_heading">
                    <h5>{item.summaryName}</h5>
                    <MainTooltip
                      tooltipText={item.summaryTooltip}
                      iconSize={15}
                    />
                      {devOnlyTooltip(isDevEnvironment, item.summaryDevOnly) &&
                      <MainTooltip
                        tooltipText={"Dev Only"}
                        tooltipIcon={"development"}
                        iconSize={15}
                    />
                    }
                  </div>
                  <div className="footstrike-container">
                    <FootStrikeCardFoot
                      whichFoot={"left"}
                      footData={
                        !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[0]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[0]
                        ]
                      }
                    />
                    <FootStrikeCardFoot
                      whichFoot={"right"}
                      footData={
                        !selectedActivityType ?
                        data?.[item.summaryPrimaryKey]?.[
                          item.summaryMetricKeys[1]
                        ] : 
                        data?.[item.summaryPrimaryKey]?.[selectedActivityType?.index]?.[
                          item.summaryMetricKeys[1]
                        ]
                      }
                    />
                  </div>
                </div>
              );
            } else {
              return null; // Handle cases where neither condition is met
            }
          } else {
            return null;
          }
        })}
      </div>
    </div>
  ) : null;
};

export default SessionSummary;
